import { Sport } from "../../redux/slices";
import { PlayBase } from "./generic-play";

export enum BasketballCourtView {
  FRONTCOURT = "FRONT-COURT",
  BACKCOURT = "BACK-COURT",
  FULLCOURT = "FULL",
}

export interface BasketballPlayProperties {
  outOfBoundsEnd: boolean;
  outOfBoundsLeft: boolean;
  outOfBoundsRight: boolean;
}

export interface BasketballPlay extends PlayBase<BasketballCourtView, BasketballPlayProperties> {
  sport: Sport.BASKETBALL;
}
